

















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class ArrowBack extends Vue {
  @Prop({ default: '16' }) readonly width?: string;
  @Prop({ default: '16' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
